import * as React from 'react';
import { V3NavProps } from 'src/components/common/template/master-page';
import V3MesoNavigation from 'src/components/common/modules/v3/meso/v3-navigation';
import V3BrandNavigation from 'src/components/common/modules/v3/brand/v3-navigation';

const V3Navigation: React.FC<V3NavProps> = (props) => { 
  const { themeType } = props;
  return <>{themeType === 'brand' ? <V3BrandNavigation {...props} /> : <V3MesoNavigation {...props} />}</>;
};

export default V3Navigation;
